import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    RemoveCompetitorFromLead as RemoveCompetitorFromLeadMutation,
    RemoveCompetitorFromLeadVariables,
    LeadCompetitorRemoveInput,
} from 'nutshell-graphql-types';

import REMOVE_COMPETITOR_FROM_LEAD from '../mutations/remove-competitor-from-lead.graphql';

export const useRemoveCompetitorFromLead = (): {
    removeCompetitorFromLead: (arg1: LeadCompetitorRemoveInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [removeCompetitorFromLead, {loading, error}] = useMutation<
        RemoveCompetitorFromLeadMutation,
        RemoveCompetitorFromLeadVariables
    >(REMOVE_COMPETITOR_FROM_LEAD);

    return {
        removeCompetitorFromLead: (input: LeadCompetitorRemoveInput) =>
            removeCompetitorFromLead({variables: {input}}),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
